import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as Sentry from '@sentry/react';

import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';

import { getFirebase } from 'react-redux-firebase';
import { useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import LoginForm from '../form';
import FormDialog from '../../../components/Dialogs/FormDialog';
import { saveLoginEmail, clearLoginEmail } from '../../../utils/login';
import { InternalApiClient } from '../../../lib/InternalApiClient';

import './index.css';

import VcOpsLogo from 'components/VcOpsLogo/VcOpsLogo';

const queryString = require('query-string');

const SignIn = () => {
  const [loading, setLoading] = useState(false);
  const [email, setEmail] = useState(null);
  const [urlEmail, setUrlEmail] = useState(null);
  const [loginErrorMessage, setLoginErrorMessage] = useState(null);
  const firebase = getFirebase();
  const db = firebase.firestore();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const params = queryString.parse(window.location.search);

  // Automatically sign the user in if they are using the 1-time login
  // link from registration
  useEffect(() => {
    const urlParamsEmail = params.email ? decodeURIComponent(params.email) : params.email;

    if (Boolean(urlParamsEmail)) {
      setUrlEmail(urlParamsEmail);
    }

    if (firebase.auth().isSignInWithEmailLink(window.location.href)) {
      if (urlParamsEmail) {
        firebase
          .auth()
          .signInWithEmailLink(urlParamsEmail, window.location.href)
          .then(() => clearLoginEmail())
          .catch(e => {
            setUrlEmail(null);
            console.error(e);
            Sentry.captureException(e);

            let message = e.message;

            if (e.code === 'auth/network-request-failed') {
              message +=
                ' If your internet connection is currently active, your network administrator may be blocking requests to googleapis.com/identitytoolkit';
            }

            enqueueSnackbar(message, {
              variant: 'error',
              autoHideDuration: 10000,
            });

            history.push('/auth/login-page/');
          });
      }
    }
  }, []);

  const initiateSignIn = async email => {
    try {
      const apiClient = new InternalApiClient();
      await apiClient.auth.loginWithEmail({
        email,
        origin: window.location.origin,
        query: window.location.search,
      });

      saveLoginEmail(email);
      setLoading(false);
      setEmail(email);
    } catch (e) {
      console.error(e);
      Sentry.captureException(e);

      let message = e.message;

      if (e.code === 'auth/network-request-failed') {
        message +=
          ' If your internet connection is currently active, your network administrator may be blocking requests to googleapis.com/identitytoolkit';
      }

      setLoginErrorMessage(message);
      setLoading(false);
    }
  };

  // 1-time login link from registration email
  if (Boolean(urlEmail) && firebase.auth().isSignInWithEmailLink(window.location.href)) {
    return (
      <div className="login-header">
        <h6 className="text-center signInHeader">Logging in...</h6>
      </div>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-center align-items-center mt-3 mt-md-0">
        <VcOpsLogo style={{ maxWidth: 225 }} />
      </div>
      <div className="login-header mt-6">
        <h6 className="signInHeader mb-0">
          {email ? 'Sign-in email sent' : 'Request a Login Link'}
        </h6>
        {!email && (
          <Typography className="text-center" style={{ maxWidth: 400, margin: '0 auto' }}>
            Enter your email address to receive your link
          </Typography>
        )}
      </div>
      <div>
        {!Boolean(email) ? (
          <>
            <LoginForm
              loading={loading}
              loginButtonLabel="Submit"
              onSubmit={values => {
                setLoading(true);
                return initiateSignIn(values.email.toLowerCase());
              }}
            />
            {/* <Box className="text-center mt-2">
              <div className="signInContainer">
                <p className="signUpTxt">
                  Don't have an account?
                  <Link to="/auth/signup" className="signUpBtn">
                    Sign Up
                  </Link>
                </p>
              </div>
            </Box> */}
          </>
        ) : (
          <div>
            <div>
              <Typography variant="body1">
                A Login Link with additional instructions was emailed to <strong>{email}</strong>.
                Be sure to check your promotions or spam folders.
                <br />
                <br />
                If you don't receive the email within a few minutes, contact{' '}
                <a href="mailto:hello@voltagecontrol.com">hello@voltagecontrol.com</a> for further
                instructions.
              </Typography>
            </div>
            <div className="login-back-container">
              <Button variant="contained" color="primary" onClick={() => setEmail(null)} fullWidth>
                Back
              </Button>
            </div>
          </div>
        )}
      </div>
      <FormDialog
        title=""
        isOpen={Boolean(loginErrorMessage)}
        handleClose={() => setLoginErrorMessage(null)}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ marginBottom: 15 }}>
            <Typography className="login-sorry">Login Error</Typography>
          </div>
          <Typography variant="body1">{loginErrorMessage}</Typography>
          {/* <div style={{ marginTop: 50, marginBottom: 20 }}>
            <Hidden xsDown>
              <Button
                variant="contained"
                color="primary"
                onClick={redirectToSignUp}
                fullWidth
              >
                SIGN UP
              </Button>
            </Hidden>
            <Hidden smUp>
              <Button
                variant="contained"
                color="primary"
                onClick={redirectToSignUp}
                size="small"
                fullWidth
              >
                SIGN UP
              </Button>
            </Hidden>
          </div> */}
        </div>
      </FormDialog>
    </div>
  );
};

export default SignIn;
